const $inject = ['$q', 'dataService', '$timeout', '$rootScope', '$http'];

const perDiemService = function ($q, dataService, $timeout, $rootScope, $http) {
    var vm = this;

    vm.getData = getData;
    vm.formatData = formatData;
    vm.save = save;
    vm.deletePerDiem = deletePerDiem;

    function getData(_callback) {
        const url = `${endPointUrl}/api/PerDiem/Get`;

        $http.get(url)
            .success(function (response, status, headers) {
                formatData(response);
                vm.ready = true;
                vm.data = response;
                _callback();
            })
            .error(function (response, status) {
                vm.ready = true;
            });
    }

    function save(perDiem, _successCallback, _failCallback) {
        const url = `${endPointUrl}/api/PerDiem/Save`;

        $http.post(url, perDiem)
            .success(function (response, status, headers) {
                _successCallback(response, status, headers);
            })
            .error(function (response, status) {
                _failCallback(response, status);
            });
    }

    function deletePerDiem(perDiem, _successCallback, _failCallback) {
        const url = `${endPointUrl}/api/PerDiem/Delete`;

        $http.post(url, perDiem)
            .success(function (response, status, headers) {
                _successCallback();
            })
            .error(function (response, status) {
                _failCallback();
            });
    }

    function formatData(data) {
        data.forEach((perDiem) => {
            perDiem.SeasonStart = perDiem.SeasonStartMonth + "/" + perDiem.SeasonStartDay;
            perDiem.SeasonEnd = perDiem.SeasonEndMonth + "/" + perDiem.SeasonEndDay;
        });
    }
};

perDiemService.$inject = $inject;

export default perDiemService;



// WEBPACK FOOTER //
// ./src/services/perDiemService.js